// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1H9C8","gfeWrapper":"CalendarEvent_gfeWrapper__1zXyL"};